/* Maison Khatib B2B quotation intent events — Oct 2026
 * Clicks indicate interest, not an enquiry received.
 * No personal or message data is collected.
 */
(function () {
  "use strict";
  if (window.__mkB2BQuoteEventsInitialized) return;
  window.__mkB2BQuoteEventsInitialized = true;

  var pathLabels = {
    "/pages/contact": "general_enquiry",
    "/pages/custom-fashion-manufacturing": "custom_production",
    "/pages/wholesale-garment-accessories": "wholesale_accessories",
    "/pages/custom-rhinestone-hotfix-designs": "rhinestone_hotfix",
    "/pages/zipper-manufacturing": "zipper_manufacturing",
    "/pages/textile-flower-manufacturing": "textile_flowers",
    "/pages/custom-fabric-covered-buttons-buckles": "covered_buttons_buckles",
    "/pages/textile-laser-cutting": "textile_laser_cutting",
    "/pages/pearl-setting-on-fabric": "pearl_setting",
    "/pages/garment-digital-printing-and-embellishment": "garment_digital_printing"
  };

  function publishEvent(name, payload) {
    try {
      // GTM dataLayer can listen to this custom event. Configuration of
      // an analytics destination is separate and required for reporting.
      if (window.dataLayer && typeof window.dataLayer.push === "function") {
        window.dataLayer.push(Object.assign({ event: name }, payload));
      }
      // Shopify custom pixel subscriptions can also consume this event.
      if (window.Shopify && window.Shopify.analytics &&
          typeof window.Shopify.analytics.publish === "function") {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (err) {
      // Analytics failures must never prevent a buyer opening WhatsApp,
      // email, phone, or submitting a contact form.
    }
  }

  function currentService() {
    var path = window.location.pathname.replace(/\/$/, "");
    return pathLabels[path] || "other";
  }

  document.addEventListener("click", function (event) {
    var a = event.target && event.target.closest && event.target.closest("a[href]");
    if (!a || !a.closest(".mk-b2b-quote-journey, .mk-b2b-mobile-contact")) return;

    var href = String(a.getAttribute("href") || "");
    var channel = "";
    if (/^https:\/\/wa\.me\/96170664457(?:\?|\/|$)/i.test(href)) channel = "whatsapp";
    else if (/^mailto:sales@maisonkhatib\.com(?:\?|$)/i.test(href)) channel = "email";
    else if (/^tel:\+96170664457(?:$|\?)/i.test(href)) channel = "phone";
    if (!channel) return;

    publishEvent("mk_b2b_quote_intent", {
      service: currentService(),
      channel: channel,
      page_path: window.location.pathname,
      intent_type: "outbound_click"
    });
  }, true);

  // Submission attempts are *not* confirmed leads. Do not collect field values.
  document.addEventListener("submit", function (event) {
    if (window.location.pathname.replace(/\/$/, "") !== "/pages/contact") return;
    var form = event.target;
    if (!form || form.nodeName !== "FORM") return;
    var input = form.querySelector('input[name="form_type"][value="contact"]');
    if (!input && !String(form.getAttribute("action") || "").includes("/contact")) return;

    publishEvent("mk_b2b_form_submit_attempt", {
      service: "general_enquiry",
      channel: "contact_form",
      page_path: window.location.pathname,
      intent_type: "form_submit_attempt"
    });
  }, true);
})();